import React from 'react';
import { Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPlus } from '@fortawesome/free-solid-svg-icons';
import {
  DetailCard,
  DetailCardHeader,
  DetailCardTitleSection,
  DetailCardTitle,
  DetailCardSubtitle,
  DetailCardCloseButton,
  DetailCardCloseIconWrapper,
  OverviewContent,
  OverviewValue,
  OverviewLabel,
  OverviewButton,
} from './Styles';
import type { DevicesOverviewProps } from './types';

const DevicesOverview: React.FC<DevicesOverviewProps> = ({
  deviceCount,
  onClose,
  onAssignDevice,
}) => {
  return (
    <DetailCard
      title={
        <DetailCardHeader>
          <DetailCardTitleSection>
            <DetailCardTitle>Devices Overview</DetailCardTitle>
            <DetailCardSubtitle>Overview of all devices</DetailCardSubtitle>
          </DetailCardTitleSection>
          <DetailCardCloseButton onClick={onClose}>
            <DetailCardCloseIconWrapper>
              <FontAwesomeIcon icon={faTimes} />
            </DetailCardCloseIconWrapper>
          </DetailCardCloseButton>
        </DetailCardHeader>
      }
    >
      <Space direction="vertical" size="large">
        <OverviewContent>
          <div>
            <OverviewValue>{deviceCount}</OverviewValue>
            <OverviewLabel>Total Devices</OverviewLabel>
          </div>
          <OverviewButton
            type="primary"
            icon={<FontAwesomeIcon icon={faPlus} />}
            size="large"
            onClick={onAssignDevice}
          >
            Assign Device
          </OverviewButton>
        </OverviewContent>
      </Space>
    </DetailCard>
  );
};

export default DevicesOverview;